import moment from 'moment'
import f from './functions'


var { error } = require('./error')

var Api = function({
    vm
}){

    var self = this;

    var axios;
    var poor;
    var apikey = null;
    var v = '/v1'

    var s = vm.$store

    var current = {}
    var cache = {}
    var loading = {}
    var config = {
        timeout : 5000
    }

    //var uidentity = f.makeid()
    /*var scache = {
        cuis : {}
    }*/

    var scasheAct = function(ids, key, resultsKey){

        if(!resultsKey) resultsKey = key

        var scache = vm.$store.state.cache


        if(!vm.$store.state.cache[key]) {
            vm.$store.commit('createCache', key)
        }

        var idtoload = _.uniq(_.filter(ids, function(id){
            return !scache[key][id]
        }))

        

        var handleResults = function(result){

            _.each(result, function(row){

                if (row[resultsKey]){
                    scache[key][row[resultsKey]] = row

                    vm.$store.commit('addToCache', key, row[resultsKey], row)
                }

            })

            var nresult = {};

            _.each(ids, function(id){
                if (scache[key][id])
                    nresult[id] = (scache[key][id])
            })

            return nresult
        }


        return {
            id : idtoload,
            handle : handleResults
        }
    }

    var scashe = function(ids, key, resultsKey){

        var waitLoading = {}

        if(!_.isArray(ids)) ids = [ids]

        if(!resultsKey) resultsKey = key

        if(!cache[key]) {
            cache[key] = {}
        }

        if(!loading[key]) {
            loading[key] = {}
        }

        var idtoloadPrev = _.uniq(_.filter(ids, function(id){
            return !cache[key][id]
        }))

        var idtoload = _.filter(idtoloadPrev, function(id){

            if(!loading[key][id]){
                loading[key][id] = true
                return true
            } 

            waitLoading[id] = true

        })

        
        var handleResults = function(result){

            _.each(result, function(row){

                if (row[resultsKey]){
                    cache[key][row[resultsKey]] = row
                    
                }

            })

            var nresult = {};

            return f.pretry(() => {

                _.each(ids, function(id){

                    if (cache[key][id]){
                        nresult[id] = (cache[key][id])

                        delete loading[key][id]
                        delete waitLoading[id]
                    }

                })

                return _.toArray(waitLoading).length == 0

            }).then(() => {
                return Promise.resolve(nresult)
            })

        }


        return {
            id : idtoload,
            handle : handleResults
        }
    }

    var screquest = function(ids, key, rkey){
        var sh = scashe(ids, key, rkey)

        if(!sh.id.length){
            return sh.handle([])
        }

        return Promise.reject(sh)
    }
   

    var waitonline = function(timeout){

    
        if(!self.platform || !self.platform.waitonline){
            return Promise.resolve()
        }

        return self.platform.waitonline(timeout)

    }

    var store = {
        add : function(id, p){

            current[id] = {
                preloaderTimeout : setTimeout(function(){

                })
            }

        },

        remove : function(id){
            if(current[id]){

                if(current[id].preloaderTimeout) clearTimeout(current[id].preloaderTimeout)

            }

            delete current[id]
        }
    }

    var clearrequest = function(action, data, to){
        data || (data = {})
        data.action = action

        return axios({
            to,
            data,
        })
    }

    var request = function(action, data, to, parameters, tr){
        if(!parameters) parameters = {}
        if (apikey) data.apikey = apikey

        if (parameters.store && vm.$store.state[parameters.store] && parameters.fromcache){
            return Promise.resolve(vm.$store.state[parameters.store])
        } 

        return waitonline(3000).then(() => {

            if(!tr) tr = 0

            data || (data = {})
            data.action = action

            console.log('action', action)
       
            return axios({
                to,
                data,
            }).then(r => {

                if (parameters.store){

                    vm.$store.commit(parameters.store, r.data)

                    return Promise.resolve(r)
                }   

                return Promise.resolve(r)
            })
            .catch(e => {

                //store.remove(id)

                if (e == 'noresponse'){

                    if(tr < 5){

                        tr++

                        return new Promise((resolve, reject) => {
    
                            setTimeout(function(){
                                request(action, data, to, parameters, tr).then(r => {
    
                                    resolve(r)
    
                                }).catch(e => {
    
                                    reject(e)
    
                                })
    
                            }, 3000)
                        })
                    }


                    vm.$message({

                        title : "No response",
                        message : "Try to connect to the internet or restart the app",
                        zIndex : 2900,
                        wrapperClassName : "notificationWrapper",
                        type : 'info'
                
                    })


                    return Promise.reject(e)

                    

                }

                return Promise.reject(e)

            })
        

        })

        
    }

    var erequest = function(action, data, to, parameters){
        return request(action, data, to, parameters).then(result => {

            return Promise.resolve(result.data || {})
        })
    }

    var kit = {

        get : (_module, vname) =>{

            if (_module){
                return s.state[_module][vname]
            }
            else{
                return s.state[vname]
            }
            
        },

        commit : (module, vname, value) =>{

            if (module){
                s.commit(module + '/' + vname, value)
            }
            else{
                s.commit(vname, value)
            }
            
        }
    }

    var install = function(api){
        _.each(api, function(d, k){
            if(!self[k]){
                self[k] = {}

                _.each(d, function(s, i){
                    self[k][i] = function(d, parameters){
                        { return erequest(s, d, null, parameters) }
                    }
                })
            }
        })
    }
    
    
    function crequest(action, {

        module,
        value,
        time,
        refresh

    } = {}, data, to){


        var cachekey = module || 'common'
        
        time || (time = 'inf')

        cache[cachekey] || (cache[cachekey] = {})

        if (refresh){
            cache[cachekey][value] = null
        }
       
        if ((!cache[cachekey][value] || !cache[cachekey][value].time || cache[cachekey][value].data ||
                
            (cache[cachekey][value].time != 'inf') && moment(cache[cachekey][value].time) > moment())){

            return request(action, data, to).then(result => {

                cache[cachekey][value] || (cache[cachekey][value] = {})

                if(time == 'inf'){
                    cache[cachekey][value].time = 'inf'
                }
                else{
                    cache[cachekey][value].time = moment().add(time, 'milliseconds').format(); 
                }

                cache[cachekey][value].data = result.data

                return result.data

            })

        }

        else
        {
            return Promise.resolve(cache[cachekey][value].data)
        }

        
    }

    self.apikey = function(_apikey){
        apikey = _apikey
    }

    self.clearStore = function(store){
        vm.$store.commit(store, null)
    }

    self.clearCache = function(key){
        vm.$store.commit('clearCache', key)
    }

    self.setaxios = function(_a){
        axios = _a
    }

    self.setrequest = function(_a){
        poor = _a
    }

    self.convert = {
        name : function(name){

            var ld = name

            name = f.flbb(name.replace(/\([^()]*\)/g, '').replace(/;/g, ','));

            var pname = name.split(', ');

            name = pname.reverse().join(', ')

            //console.log("NN", ld + " -> " + name)

            return name
        },
        diseases : function(results){

            var diseases = _.filter(results.data, function(d){
                return d.STY == 'Disease or Syndrome'
            })

            _.each(diseases, function(d){
                d.Name = self.convert.name(f.deep(d, 'spec.Name') || d.Name || d.CUIName)

                if(!d.spec) d.spec = {}

                if(d.spec.ReqCUI == d.CUI) d.spec.ReqCUI = d.spec.baseReqCUI
                if(d.spec.ReqCUI == d.CUI) d.spec.ReqCUI = null

                if(d.spec.PrefCUI == d.CUI) d.spec.PrefCUI = d.spec.basePrefCUI
                if(d.spec.PrefCUI == d.CUI) d.spec.PrefCUI = null

                if(d.spec.S1 == d.CUI) d.spec.S1 = d.spec.baseS1
                if(d.spec.S1 == d.CUI) d.spec.S1 = null

                if(d.spec.S2 == d.CUI) d.spec.S2 = d.spec.baseS1
                if(d.spec.S2 == d.CUI) d.spec.S2 = null

                if(d.spec.S3 == d.CUI) d.spec.S3 = d.spec.baseS1
                if(d.spec.S3 == d.CUI) d.spec.S3 = null

            })

            diseases = _.sortBy(diseases, function(d){
                return -d.p
            })

            return diseases
        },

        symptoms : function(symptoms, UMLSname){

            _.each(symptoms, function(d){

                if(!UMLSname)
                    d.Name = self.convert.name(f.deep(d, 'spec.Name') || d.Name || d.CUIName)
                else
                    d.Name = self.convert.name(d.Name || d.CUIName)

                d.CUIName = d.Name

                if (d.STY){
                    if(d.STY == 'Disease or Syndrome') d.styclass = "disease"
                    if(d.STY == 'Organic Chemical' || d.RXNORMCODE) d.styclass = "drag"
                }

                if(!d.spec) d.spec = {}
            })

            return symptoms
        }
    }

    ////////////////////////// API

    self.user = {
        get : function(ids, key){
            return screquest(ids, 'user', key || 'id').catch( sh => {
                return erequest('u/info/common', {
                    id : sh.id
                }, null, {
                    store : 'usersinfo'
                }).then(results => {
                    return Promise.resolve(sh.handle(results))
                })
            }).then(r => {
                return _.toArray(r)
            })
        },
        exist : function(value, type){

            if(!type){
                return erequest('u/exist', {
                    value : value
                })
            }

            return erequest('u/'+type+'/exist', {
                value : value
            })
        }
    }

    self.account = {

        sendFcmInfo(data){
            return request('u/setFcmInfo', data);
        },

        link : function(data){
            return request("u/link", data)
        },

        signup : function(data){
            return request("u/create", data)
                .catch(e => Promise.reject(e));
        },

        info : {
            common : function(id){
                return request("u/info/common", {
                    id : id
                })
            },

            edit : function(data){

                return request("u/info/edit", data)
    
            },
        },

        another : function(data){

            return request("u/another", data).then(r => {
                return Promise.resolve(r.data)
            })

        },

        signin : function(data){

            return request("u/signinv2", data)

        },

        password : {
            checkHash : function(hash){
                return request("u/password/checkhash", {
                    hash : hash
                })
            },
            setNew : function(hash, pwdhash){
                return request("u/password/setnew", {
                    hash : hash,
                    pwdhash : pwdhash
                })
            },
            requestRestore : function(login){
                return request("u/password/requestrestore", {
                    login : login
                })
            },
            change : function(newpwd){
                return request("u/password/change", {
                    newpwd : newpwd
                })
            },
        },

        requestConfirm : {
            phone : function(data){
                return request("u/phone/requestConfirm", data)
            },
            email : function(data){
                return request("u/email/requestConfirm", data)
            }
        },

        isconfirm : {
            phone : function(data){
                return request("u/phone/isconfirm", data)
            },
            email : function(data){
                return request("u/email/isconfirm", data)
            }
        },

        confirm : {
            phone : function(data){
                return request("u/phone/confirm", data)
            },
            email : function(data){
                return request("u/email/confirm", data)
            }
        },

        upload : {
            userpicture : function(data){
                return request("u/upload/userpicture", data)
            },

            sessionpicture : function(data){
                return request("u/upload/sessionpicture", data)
            },
        },

    }

    self.sessions = {

        loadcontext : function(context){
            return self.sessions.temp.cuisInfo([context]).then(cuis => {
                context.cuis = cuis

                return Promise.resolve(context)
            })
        },

        update : function(data){
            return request("sessions/update", data)
        },

        ////////////////////////// remove

        convert : function(data){
            data = _.filter(data, function(d){
                if (d.symptoms && d.query){

                    d.symptoms = JSON.parse(d.symptoms || "[]")
                    d.rsymptoms = JSON.parse(d.rsymptoms || "[]")
                    d.pictures = JSON.parse(d.pictures || "[]")
                    d.query = JSON.parse(d.query)

                    if (d.diseases)
                        d.diseases = JSON.parse(d.diseases || "[]")

                    return true

                }
            })

            return data
        },

        get : function(data){
            return request("sessions/u/getp", data).then(results => {

                return Promise.resolve(self.sessions.convert(results.data))

            })
        },

        temp : {
            cuisInfo : function(sessions){
                var cuis = []
                    
                _.each(sessions, function(r){
                    cuis = cuis.concat(r.symptoms, r.rsymptoms || [], r.diseases || [])
                })

                return self.cui.get(cuis)
            },
            getWithCuisInfo : function(data){
                var r = [];

                return self.sessions.get(data).then(results => {

                    r = results
                    
                    return self.sessions.temp.cuisInfo(results)

                }).then(cuisinfo => {

                    return Promise.resolve({
                        sessions : r, 
                        cuis : cuisinfo
                    })

                }).catch(e => {
                    console.log(e)
                })
            }
        }

    }

    self.cui = {
        get : function(cuis){

            var sh = scasheAct(cuis, 'CUI')

            if(!sh.id.length){
                return Promise.resolve(sh.handle([]))
            }

            return self.wai.info.cui2({

                cui : JSON.stringify(_.uniq(sh.id))

            }).then(results => {

                var res = sh.handle(results)

                return Promise.resolve(res)

            }).catch(e => {
                console.log(e)
            })

        }
    }

    self.notifications = {
        get : function(){

            return request("notifications/get", {}).then(result => {
                return Promise.resolve(result.data || {})
            })
            
        },

        seenAll : function(key){
            return request("notifications/seenAll", {key}).then(result => {
                return Promise.resolve(result.data || {})
            })
        },

        unseenall : function(){
            return request("notifications/unseenall", {}).then(result => {
                return Promise.resolve(result.data || {})
            })
        }
    }

    self.calls = {
        peeridby : function(data){
            
            return crequest("c/peeridby", {
                module : 'callspeeridby',
                time : 'inf',
                value : (data.email || '') + (data.phone || '')
            }, data).then(data => {

                if(data.length){
                    return data[0]
                }

                return Promise.reject('emptydata')

            })
        },

        infobypeerid : function(peerid){
            return crequest("c/infobypeerid", {
                module : 'callsinfobypeerid',
                time : 10000000,
                value : peerid
            }, {
                peerid : (peerid || "").split("_")[0]
            }).then(data => {

                if(data.length){
                    return data[0]
                }

                return Promise.reject('emptydata')

            })
        },

        list : function(){
            return erequest("c/list", {})
        },

        get : function(id){
            return erequest("c/get", {id})
        },

        missedCall : function(callid){
            return request("c/missedcall", {callid}).then(result => {
                return Promise.resolve(result.data || {})
            })
        },


        context : function(context){
            return request("c/getcontext", {
                context : context
            }).then(result => {
                return Promise.resolve(result.data || {})
            })

            
        },
        contextall : function(context){

            return self.calls.context(context).then(context => {

                context = self[context.type].convert([context])[0]

                return self[context.type].loadcontext(context).then(() => {

                    return Promise.resolve(context)

                })

            })
        },

        myredirects : function(){
            return request("c/myredirects", {}).then(result => {
                return Promise.resolve(result.data || [])
            })
        },

        noanswerredirects: function(peerid){
            return request("c/noanswerredirects", {peerid}).then(result => {
                return Promise.resolve(result.data || [])
            })
        },
    }

    self.wai = {

        symptomsByText : function(data){
            return request("symptomsbytext", data, 'py').then(r => {
                
                if (r.data.symptoms)
                    r.data.symptoms = self.convert.symptoms(r.data.symptoms)

                if (r.data.tsymptoms)
                    _.each(r.data.tsymptoms, function(sp, i){
                        r.data.tsymptoms[i] = self.convert.symptoms(r.data.tsymptoms[i])
                    })
                
                return Promise.resolve(r)
            })
        },
        symptomsByPlainText : function(data){
            return request("symptomsbyplaintext", data, 'py').then(r => {
                
                if (r.data.symptoms)
                    r.data.symptoms = self.convert.symptoms(r.data.symptoms)

                if (r.data.tsymptoms)
                    _.each(r.data.tsymptoms, function(sp, i){
                        r.data.tsymptoms[i] = self.convert.symptoms(r.data.tsymptoms[i])
                    })
                
                return Promise.resolve(r)
            })
        },

        info : {
            cui : function(data){
                return request("cuiInfo", data, 'py')
            },

            cui2 : function(data){
         
                return request("cuiInfo2", data, 'py').then(r => {
            
                    _.each(r.data, function(d){
                        d.CUI = d.CUI.toUpperCase()
                    })

                    r.data = self.convert.symptoms(r.data)
                    
                    return Promise.resolve(r.data)
                })
            }
        },

        search : {
            incremental : function(data){
                return request("incrementalSearch", data, 'py')
            },

            journal : function(data){
                return request("journalSearch", data, 'py')
            },

            covidJournal : function(data){
                return request("covidJournalSearch", data, 'py')
            },
        },

        py : {
            allresd : function(data){
                return request("allresdall", data, 'py').then(results => {
                    var diseases = self.convert.diseases(results)

                    return Promise.resolve(diseases)
                })
            },
            allresddanil : function(data){
                return request("allresddanil", data, 'py')
            },
            allresdcorona : function(data){
                return request("allresdcorona", data, 'py')
            }
        },

        abstract : {
            preview : function(data){
                return request("getAbstractPreview", data, 'py')
            }
        },

        article : {
            cuis : function(data){
                return request("covidArticleCuis", data, 'py')
            },

            preview : function(data){
                return request("getArticlePreview", data, 'py')
            }
        },

        user : {
            signupnews : function(data){
                return request("user/signupnews", data, 'py')
            }
        },

        subscriptions : {
            get : function(){
                return request("subscriptions/get", {})
            }
        }

        
    }

    self.app = {
        iplocate : function(){
            return request("app/iplocate", {})
        },

        logs : {
            add : function(data, anonim){

                if(anonim) data.anonim = true

                /// type, subtype, payload
 
                return request("logs/add", data).then(result => {
                    return Promise.resolve(result.data || {})
                })
            },
            info : {

                bytype : function(data){
                    var g = f.group(data, function(d){
                        return d.type + "_" + d.subtype
                    })

                    var keys = []

                    var prms = _.map(g, function(d, i){

                        if(self.app.logs.info.types[i]){

                            keys.push(i)

                            return self.app.logs.info.types[i](d)
                        }

                    })

                    //return self.app.logs.info.types.wizard_query(g.wizard_query)

                    return Promise.all(prms).then(d => { 

                        var additional = {}

                        _.each(d, function(v, i){
                            additional[i] = v
                        })

                        return {
                            groups : g,
                            additional : additional
                        }
                    });


                },

                types : {
                    wizard_query : function(d){
                        var cuis = [];

                        _.each(d, function(d){

                            if(d.payload) {
                                cuis = cuis.concat(
                                    _.map(d.payload.diseases || [], function(c){return c.cui || c}),
                                    _.map(d.payload.symptoms || [], function(c){return c.cui || c}),
                                    _.map(d.payload.removedSymptoms || [], function(c){return c.cui || c})
                                )
                            }

                            d.date = moment(moment.utc(d.date).toDate()).local();

                            
                        })

                        cuis = _.map(cuis, function(c){
                            return c.toUpperCase()
                        })

                        return self.cui.get(cuis)
                    }
                }
            },

            get : function(){
                return request("logs/get", {}).then(result => {

                    var data = _.map(result.data, function(r){
                        r.payload = JSON.parse(r.payload || "{}")

                        return r
                    })


                    return self.app.logs.info.bytype(data).then(d => {

                        return Promise.resolve(d)
                    })
                    
                })
            }
        },
        context : function(){
            return crequest("app/context", {
                
                module : 'app',
                time : 10000000,
                value : 'context'

            }, {}).then(data => {

                if (!_.isEmpty(data)){

                    if(data.api){
                        install(data.api)
                    }

                    return data
                }

                return Promise.reject('emptydata')

            })
        },

        ping : function(){
            return clearrequest("app/ping", {})
        },

        supportTeam : function(){
            return erequest("app/supportteam", {})
        },

        sendcodea : function(d){
            return erequest("payments/sendcodea", d)
        },

        translate : function(cuis, lang){

            if(!_.isArray(cuis)) cuis = [cuis]

            if(!lang) lang = 'en'


            if(lang.indexOf('en') == 0){
                return Promise.resolve({})
            }

            var sh = scasheAct(cuis, "CUINAME" + lang, 'CUI')

            if(!sh.id.length){
                return Promise.resolve(sh.handle([]))
            }

            return request("translator/cuis", {

                cuis : JSON.stringify(_.uniq(sh.id)),
                lang : lang

            }).then(results => {

                var res = sh.handle(results.data)

                return Promise.resolve(res)

            }).catch(e => {

                return Promise.resolve({})
            })

        },

        /*plans : {
            offers : {

            }
        }*/
    }

    self.external = {
        article : function(articlesha){
            return poor({
                to : 'https://wellai.health/ai/articles/'+articlesha+'.json',
            })
        }
    }

    self.doctor = {
        available : function(data){
            return request("doctor/available", data).then(result => {
                return Promise.resolve(result.data || [])
            })
        },

        availableMy: function(data){
            return request("doctor/availableMy", data).then(result => {
                return Promise.resolve(result.data || [])
            })
        },

        medicalprofile : function(data){
            return request("doctor/medicalprofile", data).then(result => {
                return Promise.resolve(result.data || {})
            })
        },

        invitePatient(data) {
            return request("doctor/invitePatient", data)
            .then(result => Promise.resolve(result.data || {}));
        },

        inviteRemove(invite) {
            return request("doctor/inviteRemove", {
                email : invite.patientEmail
            })
            .then(result => Promise.resolve(result.data || {}));
        },

        getPatients(){
            return request("doctor/getPatients")
            .then(result => result.data || []);
        },

        getInvites(){
            return request("doctor/getInvites")
            .then(result => result.data || []);
        },

        

        removeConnection(data) {
            return request("doctor/removeConnection", data)
        },

        getRefillRequests() {
            return request("doctor/refillRequest")
                .then(result => result.data || []);
        },
        getRefillRequestObject(data) {
            return request("doctor/getRefillRequestObject", data)
                .then(result => result.data || {});
        },
        getRefills(data) {
            return request("doctor/getRefills", data)
                .then(result => result.data);
        },

        getRefillRequestBody(data) {
            return request("doctor/refillRequest/getBody", data)
                .then(result => result.data)
        },

        approveRefillRequest(data) {
            return request("doctor/refillRequest/approve", data)
                .then(result => result.data);
        },

        rejectRefillRequest(data) {
            return request("doctor/refillRequest/reject", data)
                .then(result => result.data);
        },

        saveRefill(data) {
          return request("doctor/refillRequest/save", data);
        },

        deleteRefill(data) {
            return request("doctor/refillRequest/delete", data);
        },

        edit : {
            medicalprofile : function(data){
                return request("doctor/edit/medicalprofile", data)
            }, 
        }
    }

    self.patient = {

        getMyDoctors() {
            return request("u/getMyDoctors")
            .then(result => result.data || [])
        },

        getMyRefills(data) {
            return request("u/getMyRefills", data)
                .then(result => result.data || [])
        },

        requestRefill(data) {
          return request("u/requestRefill", data)
              .then(result => result.data);
        },

        sendRequest(data) {
            return request("u/sendRequest", data)
                .then(result => result.data);
        },

        getMyRefillRequests(data) {
            return request("u/getMyRefillRequests", data)
                .then(result => result.data);
        },

        getRefillRequestObject(data) {
            return request("u/getRefillRequestObject", data)
                .then(result => result.data);
        },

        doctorByInvite(code) {
            return request("u/doctorByInvite", {code})
                .then(res => res.data)
        },

        connectWithDoc(code) {
            return request("u/connectWithDoc", {code})
                .then(res => res.data);
        },

        connectWithDocViaApp(data) {
            return request("u/connectWithDocAuth", data)
                .then(result => result.data);
        },

        getDoctorInfo(data) {
            return request("u/getDoctorInfo", data)
                .then(result => result.data);
        },

        removeConnection(data) {
            return request("u/removeConnection", data);
        },

        getInvites(){
            return request("u/getInvites")
            .then(result => result.data || []);
        },

        inviteRemove(invite) {
            return request("u/inviteRemove", {
                doctorId : invite.doctorId
            })
            .then(result => Promise.resolve(result.data || {}));
        },

    }

    self.appointment = {

        loadcontext : function(context){
            return self.sessions.loadcontext(context.sessionobject)
        },

        convert : function(data){
            data = _.filter(data, function(d){

                if (d.sessionobject && d.worksessionobject){
                    d.sessionobject = self.sessions.convert([d.sessionobject])[0]

                    return true
                }
               
            })

            return data
        },

        patient : {
            tomakean : function(data){

                return request("appointments/tomakean", data).then(result => {
                    return Promise.resolve(result.data || [])
                })

            }
        }
    }

    self.request = {
        conceptsRecognition : function(data){
            return request("api" + v + "/conceptsRecognition_v2", data, 'py').then(r => {

                if (r.data.concepts)
                    r.data.concepts = self.convert.symptoms(r.data.concepts, true)
                
                return Promise.resolve(r)

            })
        },

        diseasesBySymptoms : function(data){
            return request("api" + v + "/diseasesBySymptoms", data, 'py').then(r => {
                
                return Promise.resolve(r)
                
            })
        }

    }

    //// core.installed

    /*self.operations = {
        accept : d =>   { return erequest('operations/accept', d) },
        decline : d =>  { return erequest('operations/decline', d) },
        request : d =>  { return erequest('operations/request', d) },
        get : d =>      { return erequest('operations/get', d) },
        waiting : d =>  { return erequest('operations/waiting', d) },
    }

    self.connections = {
        remove : d =>   { return erequest('connections/accept', d) },
        create : d =>   { return erequest('connections/create', d) },
        get : d =>      { return erequest('connections/get', d) }
    }

    self.permissions = {
        remove : d =>   { return erequest('permissions/remove', d) },
        add : d =>      { return erequest('permissions/add', d) },
        getForMe : d => { return erequest('permissions/getForMe', d) },
        getByMe : d =>  { return erequest('permissions/getByMe', d) }
    }*/

    self.get = request
    
    return self;
}

export default Api